import { useCallback, useState } from 'react';
import { API_CORE } from '../../../../../_CORE/API/ApiCORE';
import { notify } from '../../../../../_CORE/APP/Templates/_UI/Alerts/AppAlertHost';
import { attachSecurityToken, useActionVerification } from '../../_Shared/_Hooks/useActionVerification';

const normalize = (response, fallback) => {
    const status = response?.status ?? response?.code_status ?? 500;
    if (status >= 400 || response?.success === false) throw new Error(response?.message || fallback);
    return response?.data ?? response;
};

export const useEmailAdmin = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const { authorize } = useActionVerification();

    const endpoint = useCallback((key) => {
        const value = API_CORE.ENDPOINTS[key];
        if (!value) throw new Error(`Endpoint no registrado: ${key}`);
        return value;
    }, []);

    const get = useCallback(async (key, params = {}) => {
        setIsLoading(true); setError(null);
        try {
            const response = await API_CORE.SERVICES.GET_RESOURCES(endpoint(key), params);
            return normalize(response, 'No se pudieron cargar los datos.');
        } catch (err) { setError(err); throw err; }
        finally { setIsLoading(false); }
    }, [endpoint]);

    const post = useCallback(async (key, data, config = {}) => {
        setIsLoading(true); setError(null);
        try {
            const response = await API_CORE.SERVICES.POST_RESOURCE(endpoint(key), data, config);
            return normalize(response, 'No se pudo completar la operacion.');
        } catch (err) { setError(err); throw err; }
        finally { setIsLoading(false); }
    }, [endpoint]);

    const securePost = useCallback(async (key, data, config = {}, options = {}) => {
        setIsLoading(true); setError(null);
        try {
            const url = endpoint(key);
            const token = await authorize(url);
            const payload = attachSecurityToken(data, token);
            const response = await API_CORE.SERVICES.POST_RESOURCE(url, payload, config);
            const result = normalize(response, options.errorMessage || 'No se pudo completar la operacion.');
            notify.success(options.successTitle || response?.message || 'Accion completada', options.successText || 'La operacion finalizo correctamente.');
            return result;
        } catch (err) {
            setError(err);
            if (!err?.cancelled && !err?.notified) notify.error(options.errorTitle || 'No se pudo completar', err?.message || options.errorMessage || 'Ocurrio un error.');
            throw err;
        } finally { setIsLoading(false); }
    }, [authorize, endpoint]);

    return { get, post, securePost, isLoading, error };
};
